import React from 'react';

import { CheckIcon } from '../Icon';
import { CheckList as StyledChecklist, Item, CheckIconContainer } from './wrappers';

interface IProps {
  items: string[];
  small?: boolean;
}

const CheckList = ({ items, small }: IProps) => {
  if (!items || items.length <= 0) {
    return null;
  }

  return (
    <StyledChecklist>
      {items.map((item) => (
        <Item key={item} className={(small && 'small') || undefined}>
          <CheckIconContainer>
            <CheckIcon />
          </CheckIconContainer>
          <div>{item}</div>
        </Item>
      ))}
    </StyledChecklist>
  );
};

export default CheckList;
